export default __webpack_public_path__ + "assets/777fc2cac648ff9b1a7dd3f5479e8d92.jpg";